import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["setting", "body", "handle"]
  static values = {
    url: String
  }

  connect() {
    console.log("Card controller connected", this.element.dataset.cardId, this.urlValue)
    this.timeout = null
  }

  debounce() {
    console.log("Debounce triggered")
    clearTimeout(this.timeout)
    this.timeout = setTimeout(() => this.save(), 1000)
  }

  save() {
    console.log("Saving card...")
    clearTimeout(this.timeout)

    const data = {
      card: {
        setting: this.hasSettingTarget ? this.settingTarget.value : '',
        body: this.hasBodyTarget ? this.bodyTarget.value : ''
      }
    }

    console.log("Save data:", data, "URL:", this.urlValue)

    fetch(this.urlValue, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content,
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    }).then(response => {
      console.log("Save response:", response.status)
      if (response.ok) {
        // Brief visual feedback
        this.element.classList.add('ring-2', 'ring-lime-300')
        setTimeout(() => {
          this.element.classList.remove('ring-2', 'ring-lime-300')
        }, 500)
      }
    }).catch(err => {
      console.error('Failed to save card:', err)
    })
  }
}
